import React from 'react';
import { observer } from 'mobx-react-lite';
import globalUserProfile from '../../../stores/global-user-profile';
import { UserType } from '../../../api/types/user/user-type';
import BaseLayout from '../base-layouts/base-layout';

interface ProtectedRouteProps {
  allowedRoles: UserType[];
  children: React.ReactElement;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = observer(
  ({ allowedRoles, children }) => {
    const userType = globalUserProfile.userType;

    // If no user type loaded yet, render the children (will show loading or handle in BaseLayout)
    if (!userType) {
      return children;
    }

    // Check if user's role is allowed
    if (allowedRoles.includes(userType)) {
      return children;
    }

    // User doesn't have permission, show unauthorized content with sidebar
    return <BaseLayout showUnauthorized={true} />;
  },
);
